angular.module('impactx.classificationmaterialgroup').controller('ClassificationMaterialGroupCtrl', ClassificationMaterialGroupCtrl);
ClassificationMaterialGroupCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    'ToolbarService'
];

function ClassificationMaterialGroupCtrl($scope, dataGen, $routeParams, BackService, $mdToast, ConfirmationService, ToolbarService) {
    var self = this;
    var id = $routeParams.id;

    self.save = function () {
        var dataObj = {
            data: $scope.data
        };

        return dataGen.postAsForm($scope, dataObj, "/classificationmaterialgroup/save").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    self.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(self.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    self.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.getData($scope, dataObj, "/classificationmaterialgroup/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    var init = function () {
        dataGen.getData($scope, {id: id}, '/classificationmaterialgroup/view').then(function () {
            defineButtons();
        });
    };

    init();

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return isEditable() && $scope.data.id > 0;
    }
}
